<div class="col-12">
    <div class="mb-4">
        <div class="p-4 border">
            <ul ngbNav #Bordered="ngbNav" [(activeId)]="activeTab"
                class="nav nav-tabs nav-tabs-custom nav-secondary mb-3">
                @for (group of groupBy; track $index) {
                <li [ngbNavItem]="$index + 1">
                    <a ngbNavLink (click)="onTabChange(group.value)">{{ group.label | translate }}</a>
                    <ng-template ngbNavContent>
                        <input id="custom-date-range" class="form-control flatpickr-input unset-readonly" type="text"
                            mwlFlatpickr [altInput]="true" [convertModelValue]="true" [mode]="group.mode"
                            [maxDate]="!isScheduleDate ? todayDate : ''"
                            [minDate]="isScheduleDate ? (activeTab == 3 ? getMonthScheduleMinDate() : scheduleMindate) : ''"
                            altFormat="d-m-Y" dateFormat="d-m-Y" [inline]="true" [(ngModel)]="selectedDate"
                            (flatpickrChange)="onDateChange($event)"
                            [options]="activeTab == 3 ? monthPickerOptions : datePickerOptions"
                            placeholder="{{ 'label-title.select-dates' | translate }}" />
                    </ng-template>
                </li>
                }
            </ul>
            <div class="tab-content text-muted">
                <div [ngbNavOutlet]="Bordered"></div>
            </div>
            <div class="text-center mt-3">
                <button type="button" class="btn btn-outline-secondary me-2" (click)="colseDate()">{{
                    "button-title.close" | translate }}</button>
                <button type="button" class="btn btn-secondary" (click)="confirmDate()">{{ "button-title.select" |
                    translate }}</button>
            </div>
        </div>
    </div>
</div>